/** Parity with Flutter `kHomeCarouselDisplayCount` / `pickRandomSample`. */
export const HOME_CAROUSEL_DISPLAY_COUNT = 8;

/** Fisher–Yates shuffle (mutates copy). */
function shuffleInPlace<T>(items: T[]): void {
  for (let i = items.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [items[i], items[j]] = [items[j], items[i]];
  }
}

/** Up to [count] items in a new random order (Flutter `pickRandomSample`). */
export function pickRandomHomeCarouselCars<T>(
  items: readonly T[],
  count = HOME_CAROUSEL_DISPLAY_COUNT,
): T[] {
  if (items.length === 0) {
    return [];
  }
  const copy = [...items];
  shuffleInPlace(copy);
  return copy.length <= count ? copy : copy.slice(0, count);
}
